export const evaluationTypeLabelMap = {
    evaluation360: 'common.reviewType.evaluation360',
    self: 'common.reviewType.selfEvaluation',
} as const;

export const stepperSubtitleKeyMap = {
    evaluation360: 'evaluation360Stepper.subtitle',
    self: 'selfAssessmentStepper.subtitle',
} as const;

export type EvaluationTypeLabelKey = keyof typeof evaluationTypeLabelMap;
